import { Box, Typography } from "@mui/material";
import React from "react";
import classes from "../AboutVedaz.styles";

export const COLOR_CONFIG = {
  red: { hex: "#F44336", bg: "rgba(244,67,54,0.1)", border: "rgba(244,67,54,0.3)", iconBg: "rgba(244,67,54,0.18)" },
  yellow: { hex: "#FFC107", bg: "rgba(255,193,7,0.1)", border: "rgba(255,193,7,0.3)", iconBg: "rgba(255,193,7,0.18)" },
  lightGreen: { hex: "#8BC34A", bg: "rgba(139,195,74,0.1)", border: "rgba(139,195,74,0.3)", iconBg: "rgba(139,195,74,0.18)" },
  darkGreen: { hex: "#4CAF50", bg: "rgba(76,175,80,0.1)", border: "rgba(76,175,80,0.3)", iconBg: "rgba(76,175,80,0.18)" },
};

export interface ColorBannerProps {
  colorKey: keyof typeof COLOR_CONFIG;
  Icon: React.ElementType;
  header: string;
  subtitle: string;
}

export const ColorBanner = ({ colorKey, Icon, header, subtitle }: ColorBannerProps) => {
  const { hex, bg, border, iconBg } = COLOR_CONFIG[colorKey];
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        mb: 3,
        p: { xs: 2, sm: 2.5 },
        borderRadius: "14px",
        background: bg,
        border: `1px solid ${border}`,
      }}
    >
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: "50%",
          background: iconBg,
          border: `2px solid ${hex}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          boxShadow: `0 0 20px ${hex}33`,
        }}
      >
        <Icon sx={{ color: hex, fontSize: "22px" }} />
      </Box>
      <Box>
        <Typography sx={{ fontWeight: 700, fontSize: "20px", color: hex, lineHeight: 1.2, mb: 0.25 }}>
          {header}
        </Typography>
        <Typography sx={{ fontSize: "13px", color: "rgba(255,255,255,0.55)", lineHeight: 1 }}>
          {subtitle}
        </Typography>
      </Box>
    </Box>
  );
};

export interface FeaturePointProps {
  colorKey: keyof typeof COLOR_CONFIG;
  Icon: React.ElementType;
  title: string;
  body: string;
}

export const FeaturePoint = ({ colorKey, Icon, title, body }: FeaturePointProps) => {
  const { hex, iconBg, border } = COLOR_CONFIG[colorKey];
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 2,
        mb: 2.5,
        p: 2.5,
        borderRadius: "14px",
        background: "rgba(255,255,255,0.03)",
        border: "1px solid rgba(255,255,255,0.07)",
        "&:last-child": { mb: 0 },
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: "12px",
          background: iconBg,
          border: `1px solid ${border}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          color: hex,
        }}
      >
        <Icon fontSize="small" />
      </Box>
      <Box>
        <Typography sx={classes.featureTitle}>{title}</Typography>
        <Typography sx={classes.featureBody}>{body}</Typography>
      </Box>
    </Box>
  );
};
